export default "__VITE_ASSET__32dbd20b__"